import {validateQuadrilateralLengthEvidence} from './quadrilateralEvidence.js';

// Reuse the same original-span validation and limits as the other outline
// workflow. Directions remain independent, explicitly typed assumptions.
export function validatePerimeterSegmentEvidence(value){
 validateQuadrilateralLengthEvidence(value,10000);
 if(value.directionSource!=='typed-assumed'||!Number.isFinite(value.direction)||value.direction<0||value.direction>=360||!Number.isFinite(value.enteredDirection)||Math.abs(value.enteredDirection)>360000||Math.abs(((value.direction-((value.enteredDirection%360+360)%360)+540)%360)-180)>1e-6||Object.hasOwn(value,'unmeasured'))throw Error('An entered perimeter segment must retain its typed, assumed direction.');
}
export function assertDistinctPerimeterReadings(segments){
 const seen=new Map();
 for(const [index,segment]of segments.entries()){
  const evidence=segment.sourceEvidence;if(evidence?.source!=='bluetooth')continue;
  const key=evidence.readingID.toLowerCase();
  if(seen.has(key))throw Error(`Sides ${seen.get(key)+1} and ${index+1} need separate Huepar readings. Measure each span again.`);
  seen.set(key,index);
 }
}
export function validatePerimeterClosingEvidence(value,wall=false){
 if(!value||typeof value!=='object'||value[wall?'lengthSource':'source']!=='calculated'||value.unmeasured!==true||!Number.isFinite(value.metres)||value.metres<.1||value.metres>300000||!Number.isFinite(value.direction)||value.direction<0||value.direction>=360||(wall&&value.directionSource!=='calculated')||['sourceEvidence','manualInput','enteredDirection'].some(key=>Object.hasOwn(value,key)))throw Error('The closing wall must stay calculated and unmeasured, without original instrument or manual readings.');
}
